export default "__VITE_ASSET__3fb09d42__"